import React from 'react';
/** lib **/
import { SERVICE_NAME } from '../../const';
import { SupporterVoiceList } from 'lib/supporter-voice';
/** components **/
import { LeadContents } from '../molecules';
import { FadeUp, ParallaxItem } from 'components/organisms';
/** styles,images **/
import s from '../../styles/organisms/supporter-voice.module.scss';
import BgLogo from 'assets/images/bg-logo.svg';

export const SupporterVoice: React.FC = () => {
  const reversedSupporterVoiceList = [...SupporterVoiceList].reverse();
  return (
    <div className={s.supporterVoiceWrapper}>
      <FadeUp>
        <div className={s.inner}>
          {reversedSupporterVoiceList.map((item, index) => (
            <div className={s.item} key={index}>
              <img src={require(`assets/images/${item.image}`)} alt={item.spec} />
              <div className={s.text}>
                <p className={s.spec}>{item.spec}</p>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </FadeUp>

      <LeadContents
        className={s.leadContents}
        gaActionName="サポーター登録ボタンクリック(ご登録いただいたサポーターの声)"
      >
        <h3>あなたの "あったらいいな" が現実になるかも？</h3>
        <p>
          応募にはサポーター登録をしていただく必要がございます。サポーター様にはイベントのご案内やいち早く最新情報をお届けします。
        </p>
        <p>※ 提供有無は物件によって異なります</p>
      </LeadContents>
      <ParallaxItem className={s.parallaxBg}>
        <img src={BgLogo} alt={SERVICE_NAME} />
      </ParallaxItem>
    </div>
  );
};
